import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ListBaseComponent } from 'app/shared/components/base/list-base/list-base.component';
import { Constants } from 'app/shared/constants/constants';
import { Modals } from 'app/shared/constants/modals';
import { Permissions } from 'app/shared/constants/permissions';
import { Sections } from 'app/shared/constants/sections';
import { SectionService } from 'app/shared/services/section.service';
import { PaginationService } from 'ngx-pagination';
import { EmailMessageFilter } from '../../../shared/filters/email-message.filter';
import { EmailMessage } from '../../../shared/models/email-message.model';
import { EmailMessageService } from '../../../shared/services/email-message.service';

@Component({
  selector: 'app-email-messages-list',
  templateUrl: './email-messages-list.component.html',
  styleUrls: ['./email-messages-list.component.scss'],
  providers: [PaginationService],
  encapsulation: ViewEncapsulation.None
})
export class EmailMessagesListComponent extends ListBaseComponent implements OnInit {

  fieldCollection = [
    {
      name: 'EmailMessageId',
      displayName: 'emailMessages.emailMessageIdFieldTitle',
      canSort: true,
      displayClass: "d-none d-sm-table-cell"
    },
    {
      name: 'RecipientEmailAddress',
      displayName: 'emailMessages.recipientEmailAddressFieldTitle',
      canSort: true,
      displayClass: ""
    },
    {name: 'Subject', displayName: 'emailMessages.subjectFieldTitle', canSort: true, displayClass: ""},
    {
      name: 'Status.IconClass',
      displayName: 'emailMessages.statusFieldTitle',
      canSort: false,
      displayClass: "d-none d-sm-table-cell"
    },
  ];

  emailMesssageFilter: EmailMessageFilter;
  emailMessageSendSuccessfully: string;

  get hasSendPermission(): boolean {
    return this.hasPermission(Permissions.EmailMessages_Send);
  }

  constructor(protected sectionService: SectionService, protected emailMessageService: EmailMessageService, protected modalService: NgbModal, protected translateService: TranslateService) {
    super(sectionService, Sections.EmailMessages, modalService, Modals.SendEmailMessageComponent);
  }

  ngOnInit() {
    this.emailMesssageFilter = new EmailMessageFilter();
    super.initializeView(Constants.EmailMessages_List_DefaultSortField, Constants.EmailMessages_List_DefaultSortDirectionAscending);
    this.translateService.get(['emailMessages.sendSuccessfullyMessage'])
      .subscribe(translations => {
        this.emailMessageSendSuccessfully = translations['emailMessages.sendSuccessfullyMessage'];
      });
  }

  searchFilter(event: any) {
    this.emailMesssageFilter.Subject = event.target.value.toLowerCase();
    this.getCollection();
  }

  send(emailMessage: EmailMessage) {
    this.emailMessageService.sendEmailMessage(emailMessage, () => this.getCollection(), this.emailMessageSendSuccessfully);
  }

  getCollection(pageNumber: number = 1) {
    if (pageNumber) {
      this.pageConfiguration.PageNumber = pageNumber;
    }

    this.emailMessageService.getCollectionPaginated<EmailMessage>("/email-message", this.pageConfiguration, this.emailMesssageFilter, (collection) => {
      this.collection = collection
    });
  }
}
